import React, { useState } from "react";
import { useParams } from "react-router-dom";
/** Common Components */
import CardSection from "../../../../components/ui/card/CardSection";
import RenderTabs from "../../../../components/ui/tabs/RenderTabs";
import CenterModel from "../../../../components/ui/centerModel/CenterModel";
import { decryptUrlData, } from "../../../../services/CryptoService";
/** Common Services & Data Files */
import AddEditTeamPlanning from "../../../taskPlan/tabContent/teamPlanning/AddEditTeamPlanning";
import CompletedTeamPlanning from "./feature/CompletedTeamPlanning";
import UpcomingTeamPlanning from "./feature/UpcomingTeamPlanning";

const MyTeamPlanning = () => {
  /* State*/
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState("");

  let teamId = null;
  let teamName = null;

  const { id } = useParams();
  const teamIdData = id ? decryptUrlData(id) : 0;

  if (typeof teamIdData === "object" && teamIdData !== null) {
    teamId = teamIdData.teamId;
    teamName = teamIdData.teamName;
  } else if (teamIdData) {
    teamId = teamIdData;
  }

  const tabs = [
    {
      sMenuItemCaption: "Current & Upcoming Planning",
      icon: "clarity:resource-pool-line",
      component: <UpcomingTeamPlanning teamIdData={teamIdData} searchText={searchText} />
    },
    {
      sMenuItemCaption: "Completed Planning",
      icon: "material-symbols-light:task-outline",
      component: <CompletedTeamPlanning teamIdData={teamIdData} searchText={searchText} />
    }
  ];
   //** Funcation's */
  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const handalAddModal = () => {
    setShowModal(!showModal);
  };

  const cardData = [{ key: "Team", value: teamName }];
  return (
    <div>
      <div className="team-planning center-top-space team-planning-list">
        <div className="table-grid">
          <CardSection
            cardTitle={"Team Planning List"}
            rightButton={true}
            buttonClassName="theme-btn"
            titleButtonClick={handalAddModal}
            buttonText="Team Planning"
            textWithIcon={true}
            iconName="material-symbols:add-rounded"
            fontIcon={true}
            handleChange={handleOnSearchChange}
            searchInputName="Search Planning"
            searchInput={true}
            cardInfo={true}
            cardInfoWrapper={cardData}
          >
            <RenderTabs tabs={tabs} />
          </CardSection>
        </div>
      </div>
      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={handalAddModal}
            modalTitle={"Add Team Planning"}
            modelSizeClass="w-70"
            backdropClosable={false}
          >
            <AddEditTeamPlanning teamId={teamId} teamName={teamName} onClose={handalAddModal} />
          </CenterModel>
        )}
      </div>
    </div>
  );
};

export default MyTeamPlanning;
